// vendor import
import AOS from 'aos'; // on scroll animations library

// vendor init
AOS.init();

// modules import
import commonList from './modules/list';
import borderContainer from './modules/border-container';
import widthContainerMargins from './modules/width-container-margins';
import productsSlider from './modules/products-slider';
import reviewsSlider from './modules/reviews-slider';
import faq from './modules/faq';
import mainMenu from './modules/main-menu';
import howItWorksSlider from './modules/how-it-works-slider';
import addChannelSlider from './modules/add-channel-slider';
import choosenBy from './modules/choosen-by';
import imagesAndSliders from './modules/images-and-sliders';
import contactUs from './modules/contact-us';
import stickyHeader from './modules/sticky-header';
import keyDirections from './modules/key-directions';
import mainFirstScreen from './modules/main-first-screen';
import notifications from './modules/notifications';
import customVolume from './modules/custom-volume';
import popUpOverlay from './modules/pop-up-overlay';
import customDropdown from './modules/custom-dropdown';
import customVolumeAireporter from './modules/custom-volume_aireporter';

// modules init
popUpOverlay();
mainMenu();
notifications();
commonList();
borderContainer();
widthContainerMargins();
productsSlider();
reviewsSlider();
faq();
howItWorksSlider();
addChannelSlider();
choosenBy();
imagesAndSliders();
stickyHeader();
keyDirections();
mainFirstScreen();
customVolume();
customVolumeAireporter();
contactUs();
customDropdown();